import FileSaver from "file-saver";
import { toast } from "react-toastify";
import { reportUnexpectedError } from "../../../../error-reporter";
import apiClient from "../../../apis/tenant-management/tenant-management-client";
import { CloudGovApiError } from "../../../domain/api-error";
import { BaseApplicationService } from "../../../domain/base/base-application-service";
import { ProductDocument } from "../../../domain/product-docs";

export type DocsServiceProps = {
  isLoading: boolean;
  isDownloading: boolean;
  docs: Array<ProductDocument>;
  fetchDocDetails: typeof DocsService.prototype.fetchDocDetails;
  onDocDownloadRequested: typeof DocsService.prototype.onDocDownloadRequested;
};
export class DocsService extends BaseApplicationService<DocsServiceProps> {
  state = {
    isLoading: false,
    isDownloading: false,
    docs: [],
    fetchDocDetails: this.fetchDocDetails.bind(this),
    onDocDownloadRequested: this.onDocDownloadRequested.bind(this),
  };

  private setIsLoading(isLoading: boolean) {
    this.setState({ isLoading: isLoading });
  }

  private setIsDownloading(isDownloading: boolean) {
    this.setState({ isDownloading: isDownloading });
  }

  async fetchDocDetails() {
    this.setIsLoading(true);
    try {
      const { data } = await apiClient.fetchPdtDocs();
      this.setState({ docs: data || [] });
    } catch (e) {
      reportUnexpectedError(e);
    } finally {
      this.setIsLoading(false);
    }
  }

  async onDocDownloadRequested(pdt: ProductDocument) {
    this.setIsDownloading(true);
    try {
      const { data } = await apiClient.downloadProductDocFile(pdt.productCode);
      FileSaver.saveAs(new Blob([data]), pdt.docName);
      toast.success("PDFをダウンロードしました。");
    } catch (e) {
      const apiError = new CloudGovApiError(e);
      await apiError.resolveErrorResponse();
      if (this.handleRetryableError(apiError)) {
        return;
      }
      reportUnexpectedError(e);
      toast.error(
        "マニュアルのダウンロードに失敗しました。管理者にお問い合わせください。",
      );
    } finally {
      this.setIsDownloading(false);
    }
  }
}
